export const TOOL_GROUP_ORDER = ['code-executor', 'google-search', 'google-maps', 'weather-forecast', 'gmail', 'google-calendar', 'google-drive', 'google-chat', 'tricago', 'shop-run', 'soloban', 'e3smart', 'toppie', 'github', 'atlassian'];
export const TOOL_GROUP_DEFINITIONS = {
    'code-executor': {
        label: 'Code Executor',
        description: 'Pythonコード実行ツールセット',
    },
    'google-search': {
        label: 'Google Search',
        description: 'Web検索・ページコンテンツ取得ツールセット',
    },
    'google-maps': {
        label: 'Google Maps',
        description: 'Google Maps連携ツールセット（要Google認証）',
    },
    'weather-forecast': {
        label: 'Weather Forecast',
        description: '気象情報取得ツールセット（気象庁データ）',
    },
    'gmail': {
        label: 'Gmail',
        description: 'Gmail閲覧・検索ツールセット（要Google認証）',
    },
    'google-calendar': {
        label: 'Google Calendar',
        description: 'Googleカレンダー予定管理ツールセット（要Google認証）',
    },
    'google-drive': {
        label: 'Google Drive',
        description: 'Google Driveファイル検索・閲覧ツールセット（要Google認証）',
    },
    'google-chat': {
        label: 'Google Chat',
        description: 'Google Chatスペース・メッセージ閲覧ツールセット（要Google認証）',
    },
    'tricago': {
        label: 'Tricago',
        description: 'tricago が提供する人員・週報・Kudos・プロフィール関連ツールセット（要Google認証）',
    },
    'shop-run': {
        label: 'Shop Run',
        description: '小売業務管理ツールセット（お知らせ取得）',
    },
    'soloban': {
        label: 'Soloban',
        description: '小売業向け年間商品計画最適化パイプライン実行ツールセット',
    },
    'e3smart': {
        label: 'e3smart',
        description: 'e3smart連携ビジネスデータツールセット（要e3smart認証）',
    },
    'toppie': {
        label: 'Toppie',
        description: '週報サマリー (toppie)',
    },
    'github': {
        label: 'GitHub',
        description: 'GitHub PR/コミット/Issue 取得ツールセット（要 GitHub PAT 登録）',
    },
    'atlassian': {
        label: 'Atlassian (Jira)',
        description: 'Jira 課題・スプリント取得ツールセット（要 Atlassian 認証）',
    },
};
